import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Typography, useMediaQuery, useTheme} from "@mui/material";
import {PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {StatsSectionData, SiteTemplate} from "../../types";

export function StatsSection(props: { data: StatsSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  return <div style={{backgroundColor: props.template.themeExtras.highlightColor}}>
    <SectionContainer>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      <div style={{display: "flex", flexWrap: "wrap"}}>
        {props.data.stats.map((stat, i) =>
          <div key={i} style={{
            flex: "1 0 160px",
            minWidth: "40%",
            padding: sm ? PD_LG : PD_MD,
            borderLeft: i % 2 === 1 ? `1px solid rgba(0,0,0,0.1)` : "none",
          }}>
            <StyledBoxColumn style={{alignItems: "center", textAlign: "center", gap: PD_SM}}>
              <StyledHeadingVariant default_={2} style={{color: theme.palette.primary.main, lineHeight: 1}}>
                {stat.value}
              </StyledHeadingVariant>
              <Typography style={{fontWeight: "600"}}>
                {stat.label}
              </Typography>
              {stat.description
                ? <Typography variant="body2" style={{opacity: 0.5}}>
                  {stat.description}
                </Typography>
                : null}
            </StyledBoxColumn>
          </div>
        )}
      </div>
    </SectionContainer>
  </div>;
}
